import script from "./createFileName.vue?vue&type=script&lang=ts&setup=true"
export * from "./createFileName.vue?vue&type=script&lang=ts&setup=true"

import "./createFileName.vue?vue&type=style&index=0&id=05e520a2&lang=less&scoped=true"
import "./createFileName.vue?vue&type=style&index=1&id=05e520a2&lang=less"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e520a2"]])

export default __exports__